import { Component, Input, OnInit } from '@angular/core';

import { StoreService } from '../../stores/store.service';
import { ClientSSO } from '../../entities/client-sso';
import { UtilsSendMail, IParametersForGetLinkToSendMail } from '../../infrastructure/utils-send-mail';
import { LABELS } from '../../constants/labels.constant';

@Component({
    selector: 'open-email',
    template: '<a class="login-link"  href="{{reference}}">{{linkContactUs | translate}}</a>',
    standalone: false
})
export class OpenEmailComponent implements OnInit {
  linkContactUs: string;
  reference: string;

  @Input() email: string;
  @Input() errorId: string;
  @Input() mailType: MailConfig;

  constructor(private storeService: StoreService) {}

  ngOnInit(): void {
    const client: ClientSSO = this.storeService.client;
    const mailTo: string = client && client.supportEmail ? client.supportEmail : this.email;
    if (mailTo) {
      DefaultMailConfig.mailTo = mailTo;
      MfaMailConfig.mailTo = mailTo;
      MfaContactMethodMailConfig.mailTo = mailTo;
      viewOfIncomingCall.mailTo = mailTo;
    }

    this.linkContactUs = this.setLabelValue();

    const mailConfig = this.getMailConfig();
    this.reference = UtilsSendMail.getLinkToSendMail(mailConfig);
  }

  setLabelValue(): string {
    const client: ClientSSO = this.storeService.client;
    let linkKey;
    if (client != null) {
      switch (this.mailType) {
        case MailConfig.mfaErrorMail:
          linkKey = LABELS.emailLinkMfa;
          break;

        case MailConfig.viewOfIncomingCall:
          linkKey = LABELS.contactUsMfa;
          break;

        default:
          linkKey = LABELS.contactUsClient;
          break;
      }
    } else {
      linkKey = LABELS.contactUsGeneral;
    }

    return linkKey;
  }

  getMailConfig(): IParametersForGetLinkToSendMail {
    let config: IParametersForGetLinkToSendMail;

    switch (this.mailType) {
      case MailConfig.mfaErrorMail: {
        const { mailTo, subject } = MfaMailConfig;
        const body = MfaMailConfig.bodyFn(this.errorId);
        config = { mailTo, subject, body };

        break;
      }

      case MailConfig.mfaContactMethodMailConfig: {
        const { mailTo, subject, body } = MfaContactMethodMailConfig;
        config = { mailTo, subject, body };

        break;
      }

      case MailConfig.viewOfIncomingCall: {
        const { mailTo, subject, body } = viewOfIncomingCall;
        config = { mailTo, subject, body };

        break;
      }

      default:
        config = DefaultMailConfig;
    }

    return Object.assign({}, config);
  }
}

export enum MailConfig {
  defaultMail,
  mfaErrorMail,
  mfaContactMethodMailConfig,
  viewOfIncomingCall,
}

const DefaultMailConfig = {
  mailTo: 'USTrueViewApp001@deloitte.com',
};

const MfaMailConfig = {
  mailTo: 'USTrueViewApp001@deloitte.com',
  subject: 'MFA support request',
  bodyFn: (errorId) =>
    `I need support with accessing TrueView with multi-factor authentication. Reference number ${errorId}`,
};

const MfaContactMethodMailConfig = {
  mailTo: 'USTrueViewApp001@deloitte.com',
  subject: 'MFA support request',
  body: `I need support with accessing TrueView with multi-factor authentication.`,
};

const viewOfIncomingCall = {
  mailTo: 'USTrueViewApp001@deloitte.com',
  subject: 'MFA support request',
  body: `I need support with accessing TrueView with multi-factor authentication.`,
};
